import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
import Register from '@/views/Register';
import Login from '@/views/Login';
import GoodsList from '@/views/GoodsList';
import GoodsDetails from '@/views/GoodsDetails';
import Cart from '@/views/Cart';
import Checkout from '@/views/Checkout';
import OrderSuccess from '@/views/OrderSuccess';
import OrderList from '@/views/OrderList.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    { 
      path: '/', component: Home, 
      meta: { 
        title: "Home Page - OneMall, the one online shop",
        metaTags:[
          { name: "description", content: "OneMall provides products listing , and smooth checkout experience"},
          { property: "og:description", content: "OneMall provides products listing , and smooth checkout experience"}
        ]
      } 
    },
    { path: '/mall', component: GoodsList, meta: { title: "All products - OneMall"} },
    { path: '/register', component: Register, meta: { title: "Registration - OneMall"} },
    { path: '/login', component: Login, meta: { title: "Welcome back - OneMall"} },
    { path: '/items/:productId', component: GoodsDetails, meta: { title: "Product Details - OneMall"} },
    { path: '/cart', component: Cart, meta: { title: "Shopping Cart - OneMall"} },
    { path: '/checkout', name: 'CheckOut', component: Checkout, meta: { title: "Checkout - OneMall"} },
    { path: '/complete', name: 'OrderSuccess', component: OrderSuccess, meta: { title: "Order Success - OneMall"} },
    { path: '/orders', name: 'OrderList', component: OrderList },
    { path: '/me', component: null, children: [
        { path: '/profile', component: null, meta: { title: "My Profile - OneMall Client Space"} },
        { path: '/addresses', component: null, meta: { title: "My Addresses - OneMall Client Space"} },
        { path: '/orders', component: null, meta: { title: "My Orders - OneMall Client Space"} }
    ]},
    { path: '/:notFound(.*)', component: null, meta: { title: "Page Not Found - OneMall"}  }
  ],
});

//Add Navigation Guard to make sure route meta works
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
})

export default router;